export default {
  'pages.appStore.refresh': '更新',
  'pages.appStore.install': 'デプロイ',
  'pages.appStore.cancel': 'キャンセル',
  'pages.appStore.confirmInstall': 'クラスタにデプロイ',
  'pages.appStore.installCount': '{count} 回デプロイ',
  'pages.appStore.spec':
    'CPU {cpu} コア · メモリ {memory} MiB · ストレージ {storage} GiB',
  'pages.appStore.installTitle': '{name} をデプロイ',
  'pages.appStore.installSuccess': 'デプロイ「{name}」を送信しました',
  'pages.appStore.installSuccessDescription':
    '企業クラスタでサービスを作成しています。通常 1〜2 分で起動します。状態とアクセスアドレスはマイデプロイで確認できます。',
  'pages.appStore.continueBrowsing': '閲覧を続ける',
  'pages.appStore.viewDeployments': 'マイデプロイを表示',
  'pages.appStore.title': 'デプロイテンプレート',
  'pages.appStore.description':
    'データベース、キャッシュ、運用監視ツールなどのクラウドネイティブアプリを企業専用クラスタにワンクリックでデプロイできます。',
  'pages.appStore.searchPlaceholder': '名前、タグ、説明で検索',
  'pages.appStore.empty': '一致するアプリがありません',
  'pages.appStore.allCategories': 'すべて',
  'pages.appStore.category.database': 'データベース',
  'pages.appStore.category.cache': 'キャッシュ',
  'pages.appStore.category.storage': 'ストレージ',
  'pages.appStore.category.messaging': 'メッセージキュー',
  'pages.appStore.category.devtools': '開発ツール',
  'pages.appStore.category.monitoring': 'モニタリング',
  'pages.appStore.category.other': 'その他',
  'pages.appStore.field.name': 'デプロイ名',
  'pages.appStore.field.nameHelp':
    'クラスタ内のサービス名としても使われ、デプロイ後は変更できません。',
  'pages.appStore.field.nameRequired': 'デプロイ名を入力してください',
  'pages.appStore.field.nameInvalid':
    '英小文字・数字・ハイフンのみ、英字で始まり 40 文字以内',
  'pages.appStore.field.description': '説明',
  'pages.appStore.field.inputs': '初期化パラメータ',
  'pages.appStore.field.inputRequired': '{label}を入力してください',
  'pages.appStore.deployments.title': 'マイデプロイ',
  'pages.appStore.deployments.description':
    '企業クラスタにデプロイされたアプリとサービスです。パブリックおよび内部アクセスに対応しています。',
  'pages.appStore.deployments.name': 'デプロイ名',
  'pages.appStore.deployments.type': '種類/ソース',
  'pages.appStore.deployments.status': '状態',
  'pages.appStore.deployments.endpoint': 'アクセスアドレス',
  'pages.appStore.deployments.spec': 'スペック',
  'pages.appStore.deployments.createdBy': 'デプロイ者',
  'pages.appStore.deployments.createdAt': 'デプロイ日時',
  'pages.appStore.deployments.actions': '操作',
  'pages.appStore.deployments.delete': '削除',
  'pages.appStore.deployments.deleteTitle':
    'デプロイ「{name}」を削除しますか？',
  'pages.appStore.deployments.deleteDescription':
    'データボリュームも同時に削除され、復元できません。',
  'pages.appStore.deployments.empty': 'デプロイはまだありません',
  'pages.appStore.deployments.installFromStore':
    'デプロイテンプレートからインストール',
  'pages.appStore.deployments.customDeploy': 'カスタムデプロイ',
  'pages.appStore.deployments.customTag': 'カスタム',
  'pages.appStore.deployments.publicLink': '公開アクセス',
  'pages.appStore.deployments.internalPrefix': '内部',
  'pages.appStore.status.running': '稼働中',
  'pages.appStore.status.pending': '起動中',
  'pages.appStore.status.failed': '異常',
  'pages.appStore.status.stopped': '停止',
  'pages.appStore.status.unknown': 'クラスタ未接続',
  'pages.appStore.status.paused': '一時停止中',
  'pages.appStore.deployments.edit': '変更',
  'pages.appStore.deployments.more': 'その他',
  'pages.appStore.deployments.restart': '再起動',
  'pages.appStore.deployments.pause': '一時停止',
  'pages.appStore.deployments.start': '開始',
  'pages.appStore.deployments.autoscalingTag': '自動 {min}～{max}',
  'pages.appStore.deployments.restartTitle': '「{name}」を再起動しますか？',
  'pages.appStore.deployments.restartDescription':
    'すべてのインスタンスが順に再作成されます。その間サービスが一時的に利用できない場合があります。',
  'pages.appStore.deployments.restartDone': '「{name}」を再起動しています',
  'pages.appStore.deployments.pauseTitle': '「{name}」を一時停止しますか？',
  'pages.appStore.deployments.pauseDescription':
    'すべてのインスタンスが停止し、アクセス先は利用できなくなります。設定とボリュームは保持され、いつでも再開できます。',
  'pages.appStore.deployments.pauseDone': '「{name}」を一時停止しました',
  'pages.appStore.deployments.startTitle': '「{name}」を開始しますか？',
  'pages.appStore.deployments.startDescription':
    '一時停止前のインスタンス数とオートスケール設定で再開します。',
  'pages.appStore.deployments.startDone': '「{name}」を開始しています',
  'pages.appStore.deployments.deleteDone': '「{name}」を削除しました',
  'pages.appStore.form.createTitle': 'アプリのデプロイ',
  'pages.appStore.form.editTitle': 'デプロイの変更 · {name}',
  'pages.appStore.form.exportYaml': 'YAML をエクスポート',
  'pages.appStore.form.submitUpdate': '変更を適用',
  'pages.appStore.form.viewForm': 'フォーム',
  'pages.appStore.form.viewYaml': 'YAML',
  'pages.appStore.form.copyYaml': 'YAML をコピー',
  'pages.appStore.form.copied': 'コピーしました',
  'pages.appStore.form.section.basic': '基本情報',
  'pages.appStore.form.section.resource': 'リソース',
  'pages.appStore.form.section.network': 'ネットワーク',
  'pages.appStore.form.section.advanced': '詳細設定',
  'pages.appStore.form.summaryTitle': 'リソース概要',
  'pages.appStore.form.summaryInstances': 'インスタンス数',
  'pages.appStore.form.summaryStorage': 'ボリューム',
  'pages.appStore.form.enabled': '有効',
  'pages.appStore.form.disabled': '無効',
  'pages.appStore.form.cores': '{value} コア',
  'pages.appStore.form.scalingMode': 'インスタンス',
  'pages.appStore.form.scalingFixed': '固定',
  'pages.appStore.form.scalingAuto': 'オートスケール',
  'pages.appStore.form.instances': 'インスタンス数',
  'pages.appStore.form.autoTarget': '目標値',
  'pages.appStore.form.autoTargetCpuHint':
    '平均 CPU 使用量が上限のこの割合を超えると拡張し、下回ると縮小します。',
  'pages.appStore.form.autoTargetMemoryHint':
    '平均メモリ使用量が上限のこの割合を超えると拡張し、下回ると縮小します。',
  'pages.appStore.form.instanceRange': 'インスタンス範囲',
  'pages.appStore.form.instanceRangeInvalid':
    '最大値は最小値以上にしてください',
  'pages.appStore.form.sharedVolumeNoAuto':
    '旧バージョンで作成されたストレージ付きデプロイはオートスケールに対応していません',
  'pages.appStore.form.sharedVolumeSingle':
    'このデプロイは旧バージョンで作成され、すべてのインスタンスが同じボリュームを共有するため、1 インスタンスのみ実行できます。',
  'pages.appStore.form.networkHint':
    'デプロイ後にクラスタ内アドレスが生成されます。HTTP ポートは公開でき、HTTPS 証明書が自動発行されます。',
  'pages.appStore.form.containerPort': 'コンテナポート',
  'pages.appStore.form.namePlaceholderHost': '<デプロイ名>',
  'pages.appStore.form.commandHint':
    '空欄の場合はイメージ既定の起動コマンドを使用します。',
  'pages.appStore.form.commandPlaceholder': '例：/bin/sh -c',
  'pages.appStore.form.argsPlaceholder': '例：sleep 10 && /entrypoint.sh',
  'pages.appStore.form.add': '追加',
  'pages.appStore.form.envBulkEdit': '一括編集',
  'pages.appStore.form.envBulkTitle': '環境変数の編集',
  'pages.appStore.form.envBulkPlaceholder':
    '1 行に 1 つ、= または : で区切って入力します。例：\nmongoUrl=127.0.0.1:8000\nredisUrl:127.0.0.1:8001\n- env1=test',
  'pages.appStore.form.envBulkInvalid':
    '{lines} 行目の変数名が不正です：英数字とアンダースコアのみ使用でき、数字で始めることはできません',
  'pages.appStore.form.envBulkCount':
    '環境変数 {count} 件。保存すると現在の一覧が置き換えられます',
  'pages.appStore.form.localStorage': 'ローカルストレージ',
  'pages.appStore.form.storageHint':
    '各インスタンスが独自のボリュームをマウントし、インスタンス間でデータは共有されません。',
  'pages.appStore.form.storageImmutable':
    'ボリュームは作成後に変更できません。',
  'pages.appStore.form.perInstanceVolume':
    '複数インスタンスの場合、各インスタンスが独自のボリュームを持ち、データは共有されません。アプリがこの構成に対応しているか確認してください。',
  'pages.appStore.form.addVolumeTitle': 'ボリュームを追加',
  'pages.appStore.form.volumeSize': '容量',
  'pages.appStore.form.volumeSizeRange': '容量範囲：1–500 Gi',
  'pages.appStore.form.confirm': '確定',
  'pages.appStore.form.fixErrors': '赤く表示された項目を修正してください',
  'pages.appStore.form.updateSuccess': '「{name}」の変更を送信しました',
  'pages.appStore.form.loadFailed':
    'デプロイ設定を読み込めませんでした。削除されたか、クラスタが一時的に利用できない可能性があります',
  'pages.appStore.form.backToList': 'デプロイ一覧に戻る',
  'pages.appStore.detail.eventsTab': 'イベント',
  'pages.appStore.detail.noPodsPaused':
    'デプロイは一時停止中です。一覧の「その他」から開始できます',
  'pages.appStore.detail.restartPodTitle': 'Pod「{name}」を再起動しますか？',
  'pages.appStore.detail.restartPodDescription':
    'Pod は削除され、クラスタによって自動的に再作成されます。',
  'pages.appStore.detail.restartPodDone': 'Pod「{name}」を再起動しています',
  'pages.appStore.events.type': '種別',
  'pages.appStore.events.Warning': '警告',
  'pages.appStore.events.Normal': '正常',
  'pages.appStore.events.reason': '理由',
  'pages.appStore.events.object': '対象',
  'pages.appStore.events.message': 'メッセージ',
  'pages.appStore.events.count': '回数',
  'pages.appStore.events.lastSeen': '最終発生',
  'pages.appStore.events.warningsOnly': '警告のみ',
  'pages.appStore.events.empty': 'イベントはありません',
  'pages.appStore.events.retentionHint':
    'クラスタは既定で直近 1 時間のイベントのみ保持します。',
  'pages.appStore.logs.modeLive': 'リアルタイム',
  'pages.appStore.logs.modeSnapshot': 'スナップショット',
  'pages.appStore.logs.stream.connecting': '接続中',
  'pages.appStore.logs.stream.live': '配信中',
  'pages.appStore.logs.stream.ended': '終了',
  'pages.appStore.logs.stream.error': '切断',
  'pages.appStore.logs.searchPlaceholder': 'キーワード検索',
  'pages.appStore.logs.matchCount': '{count} 行一致',
  'pages.appStore.logs.onlyMatches': '一致行のみ',
  'pages.appStore.logs.timestamps': '時刻を表示',
  'pages.appStore.logs.wrap': '折り返し',
  'pages.appStore.logs.download': '全ログをダウンロード',
  'pages.appStore.logs.downloadFailed': 'ログのダウンロードに失敗しました',
  'pages.appStore.logs.fullscreen': '全画面',
  'pages.appStore.logs.exitFullscreen': '全画面を終了（Esc）',
  'pages.appStore.logs.loading': 'ログを読み込み中…',
  'pages.appStore.logs.jumpToLatest': '最新へ移動',
  'pages.appStore.deployments.detail': '詳細',
  'pages.appStore.deployments.scale': 'スケール',
  'pages.appStore.deployments.replicas': '{replicas} レプリカ',
  'pages.appStore.scale.title': '「{name}」のレプリカ数を変更',
  'pages.appStore.scale.submit': '適用',
  'pages.appStore.scale.replicas': '目標レプリカ数',
  'pages.appStore.scale.current': '現在のレプリカ数：{replicas}',
  'pages.appStore.scale.storageLimit':
    'このデプロイは旧バージョンで作成され、すべてのインスタンスが同じボリュームを共有するため、1 インスタンスのみ実行できます。',
  'pages.appStore.scale.success':
    '「{name}」を {replicas} レプリカに変更しました',
  'pages.appStore.detail.title': 'デプロイ詳細 · {name}',
  'pages.appStore.detail.podsTab': 'Pod とモニタリング',
  'pages.appStore.detail.logsTab': 'ログ',
  'pages.appStore.detail.refresh': '更新',
  'pages.appStore.detail.podName': 'Pod 名',
  'pages.appStore.detail.podStatus': '状態',
  'pages.appStore.detail.restarts': '再起動回数',
  'pages.appStore.detail.cpu': 'CPU 使用率',
  'pages.appStore.detail.memory': 'メモリ使用率',
  'pages.appStore.detail.cpuUsage': '{used} コア / 上限 {limit} コア',
  'pages.appStore.detail.memoryUsage': '{used} MiB / 上限 {limit} MiB',
  'pages.appStore.detail.node': 'ノード / IP',
  'pages.appStore.detail.startTime': '起動時刻',
  'pages.appStore.detail.viewLogs': 'ログ',
  'pages.appStore.detail.previousLogs': '前回実行時のログ',
  'pages.appStore.detail.phase.Running': '稼働中',
  'pages.appStore.detail.phase.Pending': '起動中',
  'pages.appStore.detail.phase.Failed': '異常',
  'pages.appStore.detail.metricsUnavailable':
    'クラスタに metrics-server がないため、CPU とメモリの使用量を表示できません。',
  'pages.appStore.detail.noPods': '稼働中の Pod はありません',
  'pages.appStore.detail.autoRefreshHint': '{seconds} 秒ごとに自動更新',
  'pages.appStore.detail.tailLines': '最新 {lines} 行',
  'pages.appStore.detail.emptyLogs': 'ログ出力はありません',
  'pages.appStore.custom.image': 'コンテナイメージ',
  'pages.appStore.custom.imagePlaceholder':
    '例: nginx:1.27 または harbor.3as.cn/app:v1',
  'pages.appStore.custom.imageRequired': 'コンテナイメージを入力してください',
  'pages.appStore.custom.imageInvalid':
    'イメージ名に空白を含めることはできません',
  'pages.appStore.custom.memory': 'メモリ',
  'pages.appStore.custom.replicasRequired': 'レプリカ数を入力してください',
  'pages.appStore.custom.addPort': 'ポートを追加',
  'pages.appStore.custom.protocol': 'プロトコル',
  'pages.appStore.custom.publicAccess': '公開アクセス',
  'pages.appStore.custom.publicHttpOnly':
    '公開アクセスは HTTP プロトコルのみ対応',
  'pages.appStore.custom.portRequired': 'ポート番号を入力してください',
  'pages.appStore.custom.portDuplicate': 'ポート番号が重複しています',
  'pages.appStore.custom.envGroup': '環境変数',
  'pages.appStore.custom.envKey': '変数名',
  'pages.appStore.custom.envValue': '値',
  'pages.appStore.custom.envKeyInvalid':
    '英字または_で始まり、英数字と_のみ使用可能',
  'pages.appStore.custom.envKeyDuplicate': '環境変数名が重複しています',
  'pages.appStore.custom.mountPath': 'マウントパス（絶対パス）',
  'pages.appStore.custom.mountPathInvalid':
    '/ で始まる絶対パスである必要があります',
  'pages.appStore.custom.mountPathDuplicate': 'マウントパスが重複しています',
  'pages.appStore.custom.command': '起動コマンド',
  'pages.appStore.custom.args': '起動引数',
  'pages.appStore.custom.argsHelp': 'コンテナ引数。空白またはカンマ区切り',
  'pages.appStore.custom.submit': 'デプロイ',
  'pages.appStore.custom.success': 'カスタムデプロイ「{name}」を送信しました',
  'pages.appStore.custom.envKeyRequired': '変数名を入力してください',
  'pages.appStore.custom.mountPathRequired': 'マウントパスを入力してください',
  'pages.appStore.deployments.emptyDescription':
    'デプロイテンプレートからワンクリックでインストールするか、イメージを指定してカスタムデプロイできます。',
  'pages.appStore.images.title': 'イメージレジストリ',
  'pages.appStore.images.description':
    'プラットフォーム共有レジストリのコンテナイメージを閲覧し、タグを選んで企業クラスタにデプロイできます。',
  'pages.appStore.images.name': 'イメージ名',
  'pages.appStore.images.searchPlaceholder': 'イメージ名で検索',
  'pages.appStore.images.address': 'リポジトリアドレス',
  'pages.appStore.images.tagCount': 'タグ数',
  'pages.appStore.images.lastPushedAt': '最終プッシュ',
  'pages.appStore.images.actions': '操作',
  'pages.appStore.images.viewTags': 'タグを表示',
  'pages.appStore.images.empty': 'レジストリにイメージがありません',
  'pages.appStore.images.refresh': '更新',
  'pages.appStore.images.readOnlyHint':
    'レジストリはプラットフォームが管理しています。イメージを閲覧してデプロイに利用できます。',
  'pages.appStore.images.tag': 'タグ',
  'pages.appStore.images.digest': 'ダイジェスト',
  'pages.appStore.images.size': 'サイズ',
  'pages.appStore.images.pushedAt': 'プッシュ日時',
  'pages.appStore.images.lastPulledAt': '最終プル',
  'pages.appStore.images.inUse': '使用中',
  'pages.appStore.images.inUseCount': '{count} 件のデプロイ',
  'pages.appStore.images.deploy': 'デプロイ',
  'pages.appStore.images.delete': '削除',
  'pages.appStore.images.cancel': 'キャンセル',
  'pages.appStore.images.deleteTitle': 'イメージタグ「{name}」を削除しますか？',
  'pages.appStore.images.deleteDescription':
    'このタグはプルできなくなります。ノードに取得済みのコピーには影響しません。',
  'pages.appStore.images.deleteBlocked':
    'このタグを使用中のデプロイがあります。先に削除してください。',
  'pages.appStore.images.deleted': '{name} を削除しました',
};
